"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskService = void 0;
var axios_1 = __importDefault(require("axios"));
var TaskService = (function () {
    function TaskService(token) {
        this.baseUrl = process.env.TASKS_API;
        this.token = token;
    }
    TaskService.prototype.getTaskByUserId = function (taskUserId, profileId) {
        return __awaiter(this, void 0, void 0, function () {
            var url, configuration, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "".concat(this.baseUrl, "/v3/tasks/by-task-user");
                        configuration = {
                            headers: {
                                Authorization: "Bearer ".concat(this.token),
                                "Content-Type": "application/json",
                                "x-profile-id": profileId
                            }
                        };
                        return [4, axios_1.default.post(url, {
                                taskUserId: +taskUserId
                            }, configuration)];
                    case 1:
                        res = _a.sent();
                        return [2, res.data.data];
                }
            });
        });
    };
    return TaskService;
}());
exports.TaskService = TaskService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVGFza1NlcnZpY2UuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInNlcnZlci9zZXJ2aWNlcy9UYXNrU2VydmljZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxnREFBeUI7QUFFekI7SUFHSSxxQkFBWSxLQUFhO1FBRGYsWUFBTyxHQUFHLE9BQU8sQ0FBQyxHQUFHLENBQUMsU0FBUyxDQUFBO1FBRXJDLElBQUksQ0FBQyxLQUFLLEdBQUcsS0FBSyxDQUFBO0lBQ3RCLENBQUM7SUFDWSxxQ0FBZSxHQUE1QixVQUE2QixVQUFVLEVBQUUsU0FBUzs7Ozs7O3dCQUN4QyxHQUFHLEdBQUcsVUFBRyxJQUFJLENBQUMsT0FBTywyQkFBd0IsQ0FBQTt3QkFDN0MsYUFBYSxHQUFHOzRCQUNsQixPQUFPLEVBQUU7Z0NBQ0wsYUFBYSxFQUFFLGlCQUFVLElBQUksQ0FBQyxLQUFLLENBQUU7Z0NBQ3JDLGNBQWMsRUFBRSxrQkFBa0I7Z0NBQ2xDLGNBQWMsRUFBRSxTQUFTOzZCQUM1Qjt5QkFDSixDQUFBO3dCQUVXLFdBQU0sZUFBSyxDQUFDLElBQUksQ0FDeEIsR0FBRyxFQUNIO2dDQUNJLFVBQVUsRUFBRSxDQUFDLFVBQVU7NkJBQzFCLEVBQ0QsYUFBYSxDQUNoQixFQUFBOzt3QkFOSyxHQUFHLEdBQUcsU0FNWDt3QkFDRCxXQUFPLEdBQUcsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFBOzs7O0tBQ3ZCO0lBQ0wsa0JBQUM7QUFBRCxDQUFDLEFBekJELElBeUJDO0FBekJZLGtDQUFXIn0=